import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { SharedSimple } from '@/types/serializers';
import { ALLIANCE_AGENTS_QUERY_KEY } from './useFetchAllianceAgents';

interface ResendInvitationParams {
  id: number;
}

export default function useResendInvitation() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: ResendInvitationParams) => {
      const response = await fetch(`/agent/api/alliance_agents/${id}/resend_invitation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      if (!response.ok) {
        let errorMessage = '招待メールの再送に失敗しました';
        try {
          const errorData: { error?: string; errors?: string[] } = await response.json();
          errorMessage = errorData.errors?.[0] || errorData.error || errorMessage;
        } catch {
          // JSONパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }

      const data: SharedSimple = await response.json();
      if (!data.success) {
        throw new Error(data.error || '招待メールの再送に失敗しました');
      }

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ALLIANCE_AGENTS_QUERY_KEY });
    },
  });
}
